module.exports = __webpack_public_path__ + "img/app-store.280be3b7.svg";